<b-modal v-model="modal_requirement_50005" :size="modalSize" :header-bg-variant="headerColor"
  header-text-variant="light" no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ modalHeaderTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <template v-if="phase !== 'memo'">
        <div class="container-fluid" style="min-height: 140px;">
          <div v-if="showDTCTable">
            <div class="list-detail-top mt-2">
              <div>
                <b-button class="ml-2 mt-2" :disabled="!measureId" variant="primary" size="sm" @click="openNoteModal">
                  {{ $t('message.button_vehicle_dtc_note_modal') }}
                </b-button>
                <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
                  {{ $t('message.file_export') }}
                </b-button>
              </div>
              <div>
                <b-button class="ml-2 mt-2" :disabled="!measureId" variant="primary" size="sm" @click="reGetDtc">
                  {{ $t('message.button_vehicle_dtc_gain_again') }}
                </b-button>
              </div>
            </div>
          </div>
          <cstm-table v-if="showDTCTable" :items="cstmListItem" :columns="tableItems" class="text-nowrap ml-2 mt-2" type="simple"
            rowSelect currentSortkey="dtc" initSortDir="asc" useStripeStyle hasTabs @rowButtonClicked="clickFFD" useSort>
            <template v-slot:rowButton="{ row }">
              <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
              <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
            </template>
          </cstm-table>
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
              {{ workSupportMessage }}
            </div>
          </div>
          <ffd-modal v-if="phase === 'displayFfd'"
            :ffdTableProp="ffdData"
            :systemProp="selectedSystem"
            :ffdSystem="ffdSystem"
            :ffdDescription="dtcName"
            :isReq05=true
            :storedDataNumberProp="storedDataNumber"
            destinationAPI="wsp"
            :projectId="vehicleInfo.vehicle.project.id"
            :measureId="measureId"
            @updateLoading="isLoading = $event"
            ref="ffd_modal"
          >
          </ffd-modal>
        </div>
      </template>
      <!-- メモ画面 -->
      <template v-if="phase === 'memo'">
        <project-data ref="projectData" :vin="vin" :vehicleName="vehicleName" :displayProjectID="vehicleInfo.vehicle.project.id"
        :registrationNumber="registrationNumber" :functionName="functionName" :dataName="dataName" :memo="memo"
        :hideRegistrationNumber="hideRegistrationNumber" :diagnoseComment="diagnoseComment" />
      </template>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <template v-if="phase !== 'memo'">
      <div class="w-100 text-center ">
        <b-button  v-if="phase === 'reGet'" size="sm" :disabled="isLoading" variant="outline-primary" @click="backDTC" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button v-if="phase !== 'execute'" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
          :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
    <template v-if="phase === 'memo'">
      <button type="button" :disabled="isLoading" @click="memoClear"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">
        {{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="backDTC" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="memoSave" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </template>
</b-modal>